import { Pipe, PipeTransform } from '@angular/core';
import {  CompetitorViewData, CompetitorViewDataAvailableFields} from "@model";


@Pipe({
    name: 'competitorMobileFields',
    standalone: false
})
export class CompetitorMobileFieldsPipe implements PipeTransform {
  transform(
      competitor: CompetitorViewData,
      viewData: CompetitorViewDataAvailableFields | undefined,
      isTeamMember: boolean = false
  ): (keyof CompetitorViewData)[] {

    let fields: (keyof CompetitorViewData)[] = [];
    if (isTeamMember) {
      fields = ['fullName', 'sex', 'country']
    }
    else {
      if (competitor.teamMembers?.length) {
        fields = ['teamName', 'fullName', 'startNumber', 'paymentStatus']
      }
      else {
        fields = ['startNumber', 'fullName', 'sex', 'country', 'club', 'paymentStatus', 'categoryLabel']
      }
    }
    return [...fields].filter(f =>
      viewData?.general?.has(f)
    );
  }
}